<ion-grid
  fixed="true"
  class="ion-padding-vertical-0"
>
  <ion-row>
    <ion-col size="12">
      <div class="card-buttons">
        <div class="card-buttons--start">
          @if (isEditable) {
            <ion-button
              fill="outline"
              [routerLink]="['/posted-freight/ship-edit', freight.id]"
              routerDirection="root"
              routerLinkActive="active"
            >
              Editar
            </ion-button>
          }
          @if (isDocumentationDownloadable) {
            <lib-freight-documentation-links [freight]="freightBasic"></lib-freight-documentation-links>
          }
        </div>
        <div class="card-buttons--end">
          <lib-incidence-button [reference]="freightBasic.reference"></lib-incidence-button>
        </div>
      </div>

      @if (isPendingAcceptance) {
        <lib-price-acceptance-buttons
          [freight]="freightBasic"
          [sizeSmall]="false"
        ></lib-price-acceptance-buttons>
      }
    </ion-col>
  </ion-row>
</ion-grid>
